"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var GridColumnMenuFilterCell_1 = require("./GridColumnMenuFilterCell");
var kendo_react_dropdowns_1 = require("@progress/kendo-react-dropdowns");
/**
 * @hidden
 */
var GridColumnMenuFilterUI = /** @class */ (function (_super) {
    __extends(GridColumnMenuFilterUI, _super);
    function GridColumnMenuFilterUI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridColumnMenuFilterUI.prototype.render = function () {
        var _a = this.props, firstFilterProps = _a.firstFilterProps, hideSecondFilter = _a.hideSecondFilter, secondFilterProps = _a.secondFilterProps, logicData = _a.logicData, logicValue = _a.logicValue, onLogicChange = _a.onLogicChange;
        return (React.createElement("div", null,
            React.createElement(GridColumnMenuFilterCell_1.GridColumnMenuFilterCell, __assign({}, firstFilterProps)),
            !hideSecondFilter && (React.createElement("div", null,
                React.createElement(kendo_react_dropdowns_1.DropDownList, { data: logicData, value: logicValue, onChange: onLogicChange, className: 'k-filter-and', textField: "text" }),
                React.createElement(GridColumnMenuFilterCell_1.GridColumnMenuFilterCell, __assign({}, secondFilterProps))))));
    };
    return GridColumnMenuFilterUI;
}(React.Component));
exports.GridColumnMenuFilterUI = GridColumnMenuFilterUI;
//# sourceMappingURL=GridColumnMenuFilterUI.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-grid@3.18.0_v4dt5gqvzldvli3cocmcghfwh4/~/@progress/kendo-react-grid/dist/npm/columnMenu/GridColumnMenuFilterUI.js
// module id = 332
// module chunks = 0